var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { MarkdownContent } from '../elements/markdown-content';
import { LinkEntityButton } from './link-entity-button';
var cls = classNames('slice-key-message');
export var SliceKeyMessageDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: inherit;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    text-align: center;\n  "], ["\n    color: inherit;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    text-align: center;\n  "])))
});
var ContentStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: 2em;\n    font-weight: 300;\n    line-height: 1.35em;\n    font-family: ", ";\n    font-style: italic;\n  "], ["\n    font-size: 2em;\n    font-weight: 300;\n    line-height: 1.35em;\n    font-family: ", ";\n    font-style: italic;\n  "])), theme.FONT('serif')),
  tablet: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: 2.25em;\n  "], ["\n    font-size: 2.25em;\n  "]))),
  desktop: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: 2.5em;\n  "], ["\n    font-size: 2.5em;\n  "])))
});
var OutroStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-top: ", ";\n    font-size: 1em;\n    font-weight: 300;\n    strong, b {\n      font-weight: 500;\n    }\n  "], ["\n    margin-top: ", ";\n    font-size: 1em;\n    font-weight: 300;\n    strong, b {\n      font-weight: 500;\n    }\n  "])), theme.UNIT(8))
});
var LinksStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin-top: ", ";\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  "], ["\n    margin-top: ", ";\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  "])), theme.UNIT(8))
});
var LinkButtonStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Content: styled(MarkdownContent).attrs(cls.attr('content'))(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Outro: styled(MarkdownContent).attrs(cls.attr('outro'))(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), OutroStyles),
  Links: styled.div.attrs(cls.attr('links'))(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), LinksStyles),
  LinkButton: styled(LinkEntityButton)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), LinkButtonStyles)
};
export var SliceKeyMessage = function (props) {
  var _a, _b, _c;
  var className = props.className,
    children = props.children,
    entity = props.entity;
  var content = entity.content,
    outro = entity.outro,
    _d = entity.links,
    links = _d === void 0 ? [] : _d;
  var buttonColors = {
    fill: ((_a = entity === null || entity === void 0 ? void 0 : entity.color) === null || _a === void 0 ? void 0 : _a.value) || 'button',
    border: ((_b = entity === null || entity === void 0 ? void 0 : entity.color) === null || _b === void 0 ? void 0 : _b.value) || 'button',
    text: ((_c = entity === null || entity === void 0 ? void 0 : entity.color) === null || _c === void 0 ? void 0 : _c.value) || 'button'
  };
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, content && content.text && React.createElement(My.Content, {
    text: content.text
  }), outro && outro.text && React.createElement(My.Outro, {
    text: outro.text
  }), !!links.length && React.createElement(My.Links, null, links.map(function (link, i) {
    return React.createElement(My.LinkButton, {
      colors: buttonColors,
      key: i,
      entity: link
    });
  })), children);
};
SliceKeyMessage.defaultProps = SliceKeyMessageDefaultProps;
SliceKeyMessage.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;